/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Rails_Vibebids_CtaInputs */

const en_directory_rails_vibebids_cta = /** @type {(inputs: Directory_Rails_Vibebids_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claim your spot on the board`)
};

const zh_directory_rails_vibebids_cta = /** @type {(inputs: Directory_Rails_Vibebids_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`冲上榜单`)
};

/**
* | output |
* | --- |
* | "Claim your spot on the board" |
*
* @param {Directory_Rails_Vibebids_CtaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_rails_vibebids_cta = /** @type {((inputs?: Directory_Rails_Vibebids_CtaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Rails_Vibebids_CtaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_rails_vibebids_cta(inputs)
	return zh_directory_rails_vibebids_cta(inputs)
});
export { directory_rails_vibebids_cta as "directory.rails.vibebids_cta" }